<template>
    <div class="user-tab-wrap">
        <Menu :theme="theme3" :active-name="menuItemIndex" @on-select="changeMenuItem">
            <Row>
                <Col span="21" class="content-container"
                ><div class="menu-content">
                    <component
                        :is="
                            itemComponentNameList[
                                authorityList.length !== 0
                                    ? authorityList[menuItemIndex].dataValue
                                    : 'SYSTEM_MENU'
                            ]
                        "
                        :initDataObj="initDataObj"
                        :selectData="selectData"
                        :isEdit="isEdit"
                        :curItemObj="curItemObj"
                        :selectedAppId="selectedAppId"
                        :selectedRole="selectedRole"
                    ></component>
                </div>
                </Col>
                <Col span="3" class="menu-container">
                <div class="menu-item-wrap">
                    <MenuItem
                        :name="index"
                        v-for="(item, index) in authorityList"
                        :key="index"
                        :class="
                            index === menuItemIndex
                                ? 'ivu-menu-item-active ivu-menu-item-selected'
                                : ''
                        "
                        class="menu-wrap"
                    >
                        <Icon type="ios-key-outline" />
                        {{ item.dataName }}
                    </MenuItem>
                </div>
                <div class="btn-wrap" :class="isEdit ? 'two-btn-wrap' : ''">
                    <div class="btns">
                        <!-- 编辑 -->
                        <Button v-if="isEdit == false" type="primary" size="small" icon="ios-create" @click="handleEdit">授权</Button>
                        <template v-else>
                            <Button size="small" @click="handleCancel">取消</Button>
                            <Button type="primary" size="small" @click="handleSubmit">确定</Button>
                        </template>
                    </div>
                </div>
                </Col>
            </Row>
        </Menu>
    </div>
</template>

<script>
import EncTree from '../../../../components/EncTree.vue'
import systemMenu from './systemMenu.vue'
import resourceField from './resourceField.vue'
import interfaceService from './interfaceService.vue'
import fieldKind from './classify.vue'
import dataLevel from './hierarchical.vue'
import eventMix from '../../mix/eventMix'
import requestMix from '../../mix/requestMix'
import utils from '../../../../common/utils'

export default {
    name: 'userTab',
    components: {
        EncTree,
        systemMenu,
        resourceField,
        interfaceService,
        fieldKind,
        dataLevel
    },
    props: ['authorityListData', 'initDataObj', 'selectData', 'isEditParent', 'selectedAppId', 'selectedRole'],
    mixins: [eventMix, requestMix],
    data() {
        return {
            isEdit: false,
            theme3: 'light',
            authorityList: [],
            menuItemIndex: 0,
            curItemObj: {},
            itemComponentNameList: {
                SYSTEM_MENU: 'systemMenu',
                RESOURCES_FIELD: 'resourceField',
                INTERFACE_SERVICE: 'interfaceService',
                FIELD_KIND: 'fieldKind',
                DATA_LEVEL: 'dataLevel'
            },
            dictionary: {
                SYSTEM_MENU: 'systemMenu',
                RESOURCES_FIELD: 'resourceField',
                INTERFACE_SERVICE: 'others',
                FIELD_KIND: 'fieldKind',
                DATA_LEVEL: 'dataLevel'
            },
        }
    },
    watch: {
        authorityListData: {
            handler() {
                this.authorityList = this.authorityListData
                this.curItemObj = this.authorityList[this.menuItemIndex]
            },
            immediate: true,
            deep: true
        },
        isEditParent: {
            handler() {
                this.isEdit = this.isEditParent
            },
            immediate: true,
        }
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
        init(val) {
            this.changeMenuItem(val)
        },
        changeMenuItem(val) {
            this.menuItemIndex = val
            this.curItemObj = this.authorityList[this.menuItemIndex]
            this.$emit('changeMenuItem', this.menuItemIndex)
            this.handleCancel()
        },
        handleEdit() {
            this.isEdit = true
            this.$emit('changeIsEdit', this.isEdit)
            if (this.curItemObj.dataValue === 'SYSTEM_MENU') {
                this.$emit('requestTree')
            }
        },
        handleCancel() {
            this.isEdit = false
            this.$emit('changeIsEdit', this.isEdit)
            // 同时将编辑的树数据恢复至原始状态
            this.$emit('recoverInitData')
        },
        handleSubmit() {
            this.isEdit = false
            this.$emit('changeIsEdit', this.isEdit)
            // 遍历initDataObj数据，将所有checked为true的id挑出来，一块儿传
            const idsArr = []
            const element = this.initDataObj[this.curItemObj.dataValue]
            if (element instanceof Array) {
                if (Object.keys(element[0]).indexOf('children') > -1 || this.curItemObj.dataValue === 'SYSTEM_MENU') {
                    if (this.curItemObj.dataValue === 'RESOURCES_FIELD') {
                        utils.treeForeach(element, 'children', (node) => {
                            // if (node.checked || node.indeterminate) {
                            //     idsArr.push(node.id)
                            // }

                            if (node.children) {
                                if (node.parentId === 0) {
                                    // children中，有children，有node，是库，处理库节点的属性checked、indeterminate
                                    if (node.checked && !node.indeterminate) {
                                        idsArr.push(node.id)
                                    }
                                }
                            } else if (node.node) {
                                // children中，没children，有node，是表，处理表节点的属性checked、indeterminate
                                if (node.checked && !node.indeterminate) {
                                    idsArr.push(node.id)
                                }

                                // 由于遍历树的时候，遍历的是树的children属性，导致没有children属性的节点，虽然不显现叶子结点了，但是当前表节点的node数组也没遍历，没有注册属性
                                // 为表的各属性对象添加属性
                                if (node.node) {
                                    node.node.forEach((el) => {
                                        if (el.checked) {
                                            idsArr.push(el.id)
                                        }
                                    })
                                }
                            } else if (node.checked && !node.indeterminate) {
                                // 只有第一层，即只有库节点
                                idsArr.push(node.id)
                            }
                        })
                    } else {
                        // 树形结构
                        utils.treeForeach(element, 'children', (node) => {
                            if (node.checked || node.indeterminate) {
                                idsArr.push(node.id)
                            }
                            // if (node.checked) {
                            //     idsArr.push(node.id)
                            // }
                        })
                    }
                } else {
                    // 非树形结构
                    element.forEach((el) => {
                        if (el.checked) {
                            idsArr.push(el.id)
                        }
                    })
                }
            }
            console.log('gg====', idsArr)
            const selectDataType = this.dictionary[this.authorityList.length !== 0 ? this.authorityList[this.menuItemIndex].dataValue : 'SYSTEM_MENU']
            const selectDataTypeId = []
            if (JSON.stringify(this.selectData) !== '{}' && this.selectData[selectDataType]) {
                this.selectData[selectDataType].forEach((el) => {
                    selectDataTypeId.push(el.id)
                })
            }

            const set = new Set(selectDataTypeId)
            const newArr = Array.from(set)
            const paramObj = {
                newMenuIdList: idsArr,
                oldMenuIdList: newArr
            }

            this.$emit('updateEditInfo', paramObj)
        },
    }
}
</script>

<style lang='less' scoped>
.user-tab-wrap {
    height: 100%;

    .edit-button {
        .edit-button {
        }
    }

    /deep/ .ivu-menu {
        width: 100% !important;
        height: 100%;
        z-index: 100;
        .ivu-menu-item{
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            padding: 8px 24px;
            margin-top: 0;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            color: var(--desc-font-color);
            &:hover{
                background: var(--comp-block-bg-color) !important;
            }
        }
        .ivu-menu-item-selected{
            background: var(--comp-block-bg-color) !important;
            color: var(--comp-selected-color) !important;
        }
        .ivu-row {
            height: 100%;
            .content-container {
                padding: 16px;
                height: 100%;
                .menu-content {
                    background-color: var(--comp-block-bg-color);
                    height: 100%;
                    width: 100%;
                    // overflow: auto;
                }
            }
            .menu-container {
                height: 100%;
                background-color: var(--bg-color);
                padding-bottom: 80px;
                position: relative;
                .btn-wrap {
                    position: absolute;
                    bottom: 0px;
                    .btns {
                        display: flex;
                        justify-content: space-around;
                        align-items: center;
                        .edit-common {
                            display: inline-flex;
                            justify-content: center;
                            align-items: center;
                            width: 64px;
                            height: 28px;
                            border-radius: 6px;
                            cursor: pointer;
                        }
                        .edit-button {
                            background: #0fb2ab;
                            color: #ffffff;
                            .btn-icon {
                                font-size: 20px;
                            }
                            .btn-font {
                                font-size: 16px;
                                font-family: PingFangSC-Medium, PingFang SC;
                                font-weight: 500;
                            }
                        }
                        .edit-button-close {
                            background: #ffffff;
                            color: #4c4c4c;
                            border: 2px solid #dcdcdc;
                            .btn-icon {
                                font-size: 20px;
                            }
                            .btn-font {
                                font-size: 16px;
                                font-family: PingFangSC-Medium, PingFang SC;
                                font-weight: 500;
                            }
                        }
                    }
                }
            }
            .ivu-col {
                .ivu-menu-item {
                    color: var(--desc-font-color);
                }
                .ivu-menu-item-selected {
                    // color: var(--comp-selected-color) !important;
                    // background: var(
                    //     --theme-menu-selected-text-color
                    // ) !important;
                    box-shadow: none !important;
                }
            }
        }
        .btn-wrap {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate3d(-50%, 0, 0);
            .btns {
                display: flex;
                justify-content: space-around;
                align-items: center;
                .edit-common {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    width: 64px;
                    height: 28px;
                    border-radius: 6px;
                    cursor: pointer;
                }
                .edit-button {
                    background: #0fb2ab;
                    color: #ffffff;
                    .btn-icon {
                        font-size: 20px;
                    }
                    .btn-font {
                        font-size: 16px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                    }
                }
                .edit-button-close {
                    background: #ffffff;
                    color: #4c4c4c;
                    border: 2px solid #DCDCDC;
                    .btn-icon {
                        font-size: 20px;
                    }
                    .btn-font {
                        font-size: 16px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                    }
                }
            }
        }
        .two-btn-wrap{
            width: 100%;
        }
    }
    /deep/ .ivu-menu-light {
        background-color: var(--comp-block-bg-color);
    }
}

.edit-button1 {
    position: absolute;
    left: calc(100% - 0px);
    bottom: 55px;
    background-color: var(--theme-menu-item-selected-bg-color);
    color: #ffffff;
    height: 50px;
    width: 50px;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
    transition: all 0.2s ease-in-out;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    span {
        display: none;
        margin-right: 10px;
        white-space: nowrap;
    }
}
.edit-button1:hover {
    width: 100px;
    span {
        display: inline-block;
    }
}
</style>
